import './main.less';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import cn from 'classname';

import _isEmpty from 'lodash/fp/isEmpty';

import { baseUrl } from '../../../../../../config/route-entry-point';

const User = ({ user, intl, isHamburgerActive, logout }) => (
	<div className='actions__login__user-block'>
		<img
			className='avatar'
			src={user.avatar || 'https://placehold.it/40x40'}
		/>
		<div className='info'>
			<Link
				className={cn({
					info__nickname: true,
					inverse_text: isHamburgerActive
				})}
				to={baseUrl('/')}
			>{user.nickname}</Link>
			<div className='info__points'>
				{Math.round(user.contest_points * 100)/100 || 0} {intl('point')}
			</div>
		</div>
		<div
			className={cn({
				exit: true,
				inverse_text: isHamburgerActive
			})}
			onClick={logout}
		></div>
	</div>
);

User.propTypes = {
	user: PropTypes.object,
	intl: PropTypes.func,
	isHamburgerActive: PropTypes.bool,
	logout: PropTypes.func
};

const Login = ({ intl }) => (
	<div className='actions__login__block'>
		<a
			className='btn btn-inline shadow login'
			href='https://rocketprofit.com'
		>{intl('Login')}</a>
	</div>
);

Login.propTypes = {
	intl: PropTypes.func
};

const Main = ({
	intl, user, isHamburgerActive = false, logout
}) => {
	return (
		<div className='actions__login'>
			{_isEmpty(user)
				? (<Login intl={intl} />)
				: (<User
					user={user}
					intl={intl}
					logout={logout}
					isHamburgerActive={isHamburgerActive} />)}
		</div>
	);
};

Main.propTypes = {
	intl: PropTypes.func,
	user: PropTypes.object,
	isHamburgerActive: PropTypes.bool,
	logout: PropTypes.func
};

export default Main;


// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/market/components/login/main.js